module.exports = __webpack_public_path__ + "img/electric_pending_zone.daf6db28.svg";